import type { TRoleAction } from '@/AdminPanel/pages/Users/types/role-action.types';
import { ApiConnector } from '@/api/api.connector';

class RolesActionsApi extends ApiConnector {
  getAllRolesActions(
    limit?: number,
    page?: number,
    searchTerm?: string
  ): Promise<{
    total: number;
    data: TRoleAction[];
  }> {
    return this.call({
      path: `admin/roles_action/getAll`,
      method: 'get',
      params: {
        limit,
        page,
        searchTerm
      }
    });
  }

  getRolesById(uuid: string): Promise<TRoleAction> {
    return this.call({
      path: `admin/roles_action/${uuid}/findById`,
      method: 'get'
    });
  }

  createRolesAction(data: TRoleAction) {
    return this.call({
      path: `admin/roles_action/create`,
      method: 'post',
      body: data
    });
  }

  updateRolesAction(data: TRoleAction) {
    return this.call({
      path: `admin/roles_action/${data.uuid}/update`,
      method: 'patch',
      body: data
    });
  }
}

export const rolesActionsApi = new RolesActionsApi();
